// extracted by mini-css-extract-plugin
export var formContainer = "styles-module--formContainer--4e4a5";
export var hideIframeTopBorder = "styles-module--hideIframeTopBorder--bf4c4";